import localeCore from "../../core/locale.core";
import { useTranslation } from "../../core/translation.core";
import useShop from "../../hooks/useShop.hook";
import { LocaleText } from "../../types/locale";

export default function LocalePs({ value, ignoreBadge }: { value: LocaleText; ignoreBadge?: boolean }) {
  const { selectedShop } = useShop();

  if (!selectedShop) return null;

  return (
    <>
      {selectedShop.locales.map((locale) => {
        const text = localeCore.getLocaleValue(value, locale);

        if (!text) return null;

        return (
          <p key={locale} data-locale={locale} className="lg:flex gap-1 items-start text-sm">
            {ignoreBadge != true && <Badge text={locale} />}
            <span className="flex-1 text-sm">{text}</span>
          </p>
        );
      })}
    </>
  );
}

const Badge = ({ text }: { text: string }) => {
  return (
    <span className="inline-block shrink mr-1 text-center text-her-taggray text-sm">
      <LocaleLabel locale={text} />:
    </span>
  );
};

function LocaleLabel({ locale }: { locale: string }) {
  const { t, msg } = useTranslation();

  switch (locale) {
    case "en":
      return <>{t(msg.locale.en)}</>;
    case "zh-Hant":
      return <>{t(msg.locale.tc)}</>;
    case "zh-Hans":
      return <>{t(msg.locale.sc)}</>;
  }

  return null;
}
